import { useEffect, useState } from "react";
import { VolumeX } from "lucide-react";
import { api } from "@/lib/api";
import { audioRunning, unlockAudio } from "@/lib/push";
import { bgTimer } from "@/lib/printPush";
import { alertFor, isOrderSound } from "@/lib/orderSound";

export function OrderAlarm() {
  const [on, setOn] = useState(isOrderSound);
  const [locked, setLocked] = useState(true);
  useEffect(() => {
    const sync = () => setOn(isOrderSound());
    const unlock = () => { unlockAudio(); setTimeout(() => setLocked(!audioRunning()), 300); };
    if (navigator.userActivation?.hasBeenActive) unlock();
    window.addEventListener("fsc-sound", sync);
    document.addEventListener("pointerdown", unlock);
    document.addEventListener("keydown", unlock);
    return () => {
      window.removeEventListener("fsc-sound", sync);
      document.removeEventListener("pointerdown", unlock);
      document.removeEventListener("keydown", unlock);
    };
  }, []);
  useEffect(() => {
    if (!on) return undefined;
    let since = "";
    const check = () => api.get("/orders/alerts", { params: { since } }).then(({ data }) => { since = data.now; alertFor(data); }).catch(() => {});
    check();
    const stop = bgTimer(check, 10000);
    window.addEventListener("fsc-order-check", check);
    return () => { stop(); window.removeEventListener("fsc-order-check", check); };
  }, [on]);
  if (!on || !locked) return null;
  return (
    <button type="button" className="fixed bottom-20 left-4 z-50 flex items-center gap-2 rounded-full border border-amber-300 bg-amber-50 px-4 py-2 text-xs font-medium text-amber-900 shadow-lg transition-transform hover:scale-[1.02] md:bottom-4 md:left-[17rem]" data-testid="order-sound-unlock-btn">
      <VolumeX className="h-4 w-4 shrink-0" />Clique aqui para liberar o som dos pedidos
    </button>
  );
}
